// src/components/PropertyFormSections/WarehouseDetails.js
import React from 'react';

const WarehouseDetails = ({ formData, handleInputChange }) => {
    return (
        <div className="mb-4 p-3 bg-orange-50 rounded border border-orange-200">
            <h4 className="font-bold text-orange-700 mb-2">🏭 Warehouse/Industrial Details</h4>

            {/* Description */}
            <div className="mb-2">
                <label className="block text-sm font-medium">Description</label>
                <textarea
                    name="description"
                    value={formData.description || ''}
                    onChange={handleInputChange}
                    placeholder="Describe the warehouse property..."
                    className="border p-2 w-full text-sm"
                    rows="2"
                />
            </div>

            {/* Plot Area & Built-up Area */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Plot Area</label>
                    <input
                        type="text"
                        name="plot_area"
                        value={formData.plot_area || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 5000 sqft"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Built-up Area</label>
                    <input
                        type="text"
                        name="built_up_area"
                        value={formData.built_up_area || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 3000 sqft"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Ceiling Height & Floor Load Capacity */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Ceiling Height</label>
                    <input
                        type="text"
                        name="ceiling_height"
                        value={formData.ceiling_height || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 10 meters"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Floor Load Capacity</label>
                    <input
                        type="text"
                        name="floor_load_capacity"
                        value={formData.floor_load_capacity || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 5 tons/sqft"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Loading Docks & Dock Type */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Number of Loading Docks</label>
                    <input
                        type="number"
                        name="number_of_docks"
                        value={formData.number_of_docks || 0}
                        onChange={handleInputChange}
                        placeholder="e.g., 4"
                        className="border p-2 w-full text-sm"
                        min="0"
                    />
                </div>
                <div>
                    <label className="block text-sm">Dock Type</label>
                    <input
                        type="text"
                        name="dock_type"
                        value={formData.dock_type || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Truck level"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Power Supply & Water Supply */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Power Supply</label>
                    <input
                        type="text"
                        name="power_supply"
                        value={formData.power_supply || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 1000 KVA"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Water Supply</label>
                    <input
                        type="text"
                        name="water_supply"
                        value={formData.water_supply || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Commercial line"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Fire Safety & Security System */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Fire Safety</label>
                    <input
                        type="text"
                        name="fire_safety"
                        value={formData.fire_safety || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Sprinkler system"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Security System</label>
                    <input
                        type="text"
                        name="security_system"
                        value={formData.security_system || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., CCTV, Guard"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Road Access & Truck Parking */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Road Access</label>
                    <input
                        type="text"
                        name="road_access"
                        value={formData.road_access || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., NH-4"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Truck Parking</label>
                    <input
                        type="text"
                        name="truck_parking"
                        value={formData.truck_parking || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 20 trucks"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Proximity to Highway & Airport */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Proximity to Highway</label>
                    <input
                        type="text"
                        name="proximity_to_highway"
                        value={formData.proximity_to_highway || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 2 km"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Proximity to Airport</label>
                    <input
                        type="text"
                        name="proximity_to_airport"
                        value={formData.proximity_to_airport || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 15 km"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Proximity to Railway */}
            <div className="grid grid-cols-1 gap-2">
                <div>
                    <label className="block text-sm">Proximity to Railway</label>
                    <input
                        type="text"
                        name="proximity_to_railway"
                        value={formData.proximity_to_railway || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 5 km"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Checkboxes - Amenities */}
            <div className="grid grid-cols-2 gap-2 mt-2">
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="is_air_conditioned"
                        checked={formData.is_air_conditioned || false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Air Conditioned
                </label>
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="has_crane_facility"
                        checked={formData.has_crane_facility || false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Crane Facility
                </label>
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="has_weighbridge"
                        checked={formData.has_weighbridge || false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Weighbridge
                </label>
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="has_employee_facilities"
                        checked={formData.has_employee_facilities || false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Employee Facilities
                </label>
                <label className="flex items-center text-sm col-span-2">
                    <input
                        type="checkbox"
                        name="has_office_space"
                        checked={formData.has_office_space || false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Office Space
                </label>
            </div>

            {/* Warehouse Area */}
            <div className="mt-2">
                <label className="block text-sm">Warehouse Area</label>
                <input
                    type="text"
                    name="warehouse_area"
                    value={formData.warehouse_area || ''}
                    onChange={handleInputChange}
                    placeholder="e.g., 10000 sqft"
                    className="border p-2 w-full text-sm"
                />
            </div>
        </div>
    );
};

export default WarehouseDetails;